import { CalendarGridMode } from '../../constants/calendarGrid'
import { HOUR_MINUTES, WEEK_DAYS } from '../../constants/date'

export const CALENDAR_GRID_MODES_DEFAULT = [
  CalendarGridMode.month,
  CalendarGridMode.week,
]

export const CALENDAR_GRID_DAY_COUNT = WEEK_DAYS

export const CALENDAR_GRID_WEEK_STARTS_ON = 1

export const CALENDAR_GRID_MINUTES_PER_ROW = HOUR_MINUTES

export const CALENDAR_GRID_EMPTY_COUNT = 0

export const CALENDAR_GRID_RANGE_SEPARATOR = ' – '

export const CALENDAR_GRID_TIME_SEPARATOR = ':'

export const CALENDAR_GRID_DROP_AREA_PREFIX = 'calendar-grid-day-'

export const CalendarGridDropType = {
  time: 'time',
}

export const QA_NAME_CALENDAR_GRID = 'calendarGrid'
